import "@/components/Layout/Table/TableRow/TableRow.scss";

import { FC } from "react";
import { useTranslation } from "react-i18next";

import { AdditionalColumnMap } from "@/components/Portal/components/PortalDeviceListFilter/types";
import { ExtendedSimCardDetail } from "@/hooks/useExtendedSims";
import {
  formatRoamingVolume,
  getFirstOfSortedRoaming,
} from "@/utils/deviceUtils";
import { Status } from "@/utils/enums";

interface RoamingColumnsProps {
  device: ExtendedSimCardDetail;
  additionalColumns: AdditionalColumnMap;
}

export const RoamingColumns: FC<RoamingColumnsProps> = ({
  device,
  additionalColumns,
}) => {
  const { t } = useTranslation();
  const { roamingDataConsumption, roamingOpenRuntime, roamingStatus } =
    additionalColumns;

  // We want only the most important of maximum three roaming infos displayed here.
  const roamingInfo = getFirstOfSortedRoaming(device);

  return (
    <>
      {roamingDataConsumption && (
        <td data-testid="td-roaming-consumption">
          {roamingInfo?.remainingVolume !== undefined &&
          roamingInfo?.initialVolume !== undefined
            ? formatRoamingVolume(
                roamingInfo.initialVolume - roamingInfo.remainingVolume,
                roamingInfo.usageZone,
              )
            : "-"}
        </td>
      )}
      {roamingOpenRuntime && (
        <td data-testid="td-roaming-runtime">
          {roamingInfo?.remainingDays !== undefined &&
          roamingInfo?.initialDays !== undefined
            ? `${roamingInfo?.remainingDays}/${roamingInfo?.initialDays} ${t(
                "Common.days",
                {
                  ns: "translation",
                },
              )}`
            : "-"}
        </td>
      )}
      {roamingStatus && (
        <td data-testid="td-roaming-status">
          {roamingInfo?.roamingStatus === Status.active
            ? t("cockpit.deviceList.row.active")
            : "-"}
        </td>
      )}
    </>
  );
};
